// extracted by mini-css-extract-plugin
export default {"text":"LabelInput_text__5yQz+"};